export default __webpack_public_path__ + "static/media/fontainebleaumini.75ee6ab1.jpg";